import km from 'keymirror'
import _ from 'underscore'

export default _.extend({}, km({
    DIRECT_SALES_GETDIRECTSALESMENUS_SUCCESS: null,
    DIRECT_SALES_GETDIRECTSALESMENUS_ERROR: null,
    DIRECT_SALES_GETDIRECTSALESRECOMMEND_SUCCESS: null,
    DIRECT_SALES_GETDIRECTSALESRECOMMEND_ERROR: null,
    /*yeoman-template-point-1*/
}))